import { Injectable } from "@angular/core";
import { AppConfig } from "../../shared/config/app-config";
import { ApiClientHelper } from "../helpers/api-client.helper";
import { AuthenticationService } from "./authentication.service";
import { LocalStorageService } from "./local-storage.service";

@Injectable()
export class DeliveryService {


    constructor(
        private apiClientHelper: ApiClientHelper,
        public config: AppConfig,
        public authService: AuthenticationService,
        public localStorage: LocalStorageService
    ) { }

    get context() {
        let context = this.authService.getContextUser();
        switch (context) {
            case 'area-manager':
            case 'aggregators':
                context = 'aggregator';
                break;
            case 'super-aggregators':
                context = 'super-aggregator';
                break;
            case 'agents':
                context = 'agent';
                break;
        }
        return context;
    }

    subContext(context) {
        let subContext = '';
        switch (context) {
            case 'supreme-aggregator':
                subContext = 'super-aggregator';
                break;
            case 'super-aggregator':
                subContext = 'aggregator';
                break;
        }
        return subContext;
    }

    canUseDeliveryService() {
        return this.config.CAN_USE_DELIVERY_SERVICE;
    }

    getDeliveryFee(deliveryAreaCode: string): Promise<any> {
        const url = this.config.MONIEPOINT_DELIVERY_SERVICE + `/api/v1/delivery-areas/${deliveryAreaCode}/fee`;
        return this.apiClientHelper.getForPromise(url, true, false, false, {}, {}, false);
    }
}